export default __webpack_public_path__ + "../staticImages/campaign-quote-top.svg";